import LocomotiveScroll from 'locomotive-scroll';

import { debounce } from '../utils/debounce';
import { breakpoints } from '../utils/breakpoints';

// import handleFooterOverflow from './handleFooterOverflow';

// handleFooterOverflow();

export let scroll;

const locomotive = () => {
  const scrollContainer = document.querySelector('[data-scroll-container]');

  scroll = new LocomotiveScroll({
    el: scrollContainer,
    smooth: true,
    offset: ['20%', 0],
    getDirection: true,
  });

  const handleWindowResize = () => {
    if (window.innerWidth < breakpoints.tablet) return;

    scroll.update();
  };

  window.addEventListener('resize', debounce(handleWindowResize), 300);

  return scroll;
};

export default locomotive;
